import {NickIRichTextOptions} from './nick.i.rich.text.options';

export interface INickOptionsField {
    [key: string]: any;
    mask: string;
    keyFieldAccessor: string;
    valueField: string;
    keyField: string;
    persistMask: boolean;
    multiple: boolean;
    filter: any;
    title: any;
    filterCalculated: any;
    separator: string;
    hiddenTitle: boolean;
    modelXref: string;
    modelRepeat: string;
    fieldRepeat: string;
    fieldXref: string;
    fieldType: string;
    enumType: string;
    format: string;
    classNames: string;
    publicRead: boolean;
    range: boolean;
    defaultInclude: boolean;
    isRichText: boolean;
    timepicker: boolean;
    richTextConfig: NickIRichTextOptions;
    validators: any;
    attributes: any;
}
